import React, { Component } from 'react';
import {Route, BrowserRouter, Switch} from 'react-router-dom';


import './App.css';

import Login from './containers/Login/Login';
import Menu from './containers/MainMenu';
import Logout from './containers/Login/Logout'
import LoginReset from './containers/Login/LoginReset'
import LoginNewPassword from "./containers/Login/LoginNewPassword";
import Order from "./components/Order/Order";

class App extends Component {
  render() {
    return (
        <BrowserRouter basename='/'>
        <Switch>
                <Route exact path="/" component={Menu}/>
                <Route exact path="/login" component={Login}/>
                <Route exact path="/logout" component={Logout}/>
                <Route exact path="/reset" component={LoginReset}/>
                <Route exact path="/place-order/:data"  component={Order}/>
                <Route exact path="/confirm-reset/:token" component={LoginNewPassword}/>
        </Switch>
        </BrowserRouter>

    );
  }
}

export default App;
